import React from 'react'

const AddMilestone = () => {
  return (
    <div>AddMilestone</div>
  )
}

export default AddMilestone